import styled from "@emotion/styled";

export const FilterDropdownClearButton = styled.button`
  background: ${props => props.theme.surface.main.primary.default};
  color: ${props => props.theme.button.tertiary.text.default};
  padding: 12px 14px 12px 14px;
  border-radius: 14px;
  border: 0;
  width: 100%;
  user-select: none;
  text-align: center;

  &:disabled {
    background: ${props => props.theme.button.secondary.surface.disabled};
    color: ${props => props.theme.font.disabled};
  }
`;
